import 'cookieconsent';

window.addEventListener("load", function () {
	// Don't show cookieconsent for logged in users.
	if(document.body.classList.contains('admin-bar')) {
		return;
	}

	window.cookieconsent.initialise({
		"palette": {
			"popup": {
				"background": "#dadada",
				"text": "#4a4a4a"
			},
			"button": {
				"background": "#005190",
				"text": "#ffffff"
			}
		},
		"theme": "edgeless",
		"content": {
			"message": "Diese Webseite verwendet Cookies, um bestimmte Dienste und Funktionen bereitzustellen.",
			"dismiss": "Ok!",
			"link": "Mehr erfahren",
			"href": "/datenschutz"
		}
	})
});



// WEBPACK FOOTER //
// ./assets/src/js/components/cookieconsent.js